export default __webpack_public_path__ + "static/media/Average_Rating_vs_Number_of_Instructors_Without_0.8d63e319.png";